import { Alert } from 'react-bootstrap';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import { selectFeedbackMessages } from '../../store/selectors';
import { removeMessage } from '../../store/slices/feedbackSlice';
import { MessageSeverity } from '../../types';

const severityToVariant: Record<MessageSeverity, string> = {
  [MessageSeverity.SUCCESS]: 'success',
  [MessageSeverity.INFO]: 'info',
  [MessageSeverity.WARNING]: 'warning',
  [MessageSeverity.ERROR]: 'danger',
};

export default function FeedbackMessages() {
  const messages = useAppSelector(selectFeedbackMessages);
  const dispatch = useAppDispatch();

  if (!messages.length) return null;

  return (
    <div className="hcf-feedback__messageContainer">
      {messages.map((msg) => (
        <Alert
          key={msg.id}
          variant={severityToVariant[msg.severity] || 'info'}
          className="hcf-feedback__message"
          dismissible
          onClose={() => dispatch(removeMessage(msg.id))}
        >
          {msg.message}
        </Alert>
      ))}
    </div>
  );
}
